import { Component } from '@angular/core';

@Component({
  selector: 'app-cortina',
  standalone: true,
  imports: [],
  templateUrl: './cortina.component.html',
  styleUrl: './cortina.component.scss'
})
export class CortinaComponent {

}
